import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const DetailPageLayout = ({
  title,
  subtitle,
  backLink,
  actions,
  children,
  className = '',
  ...props
}) => {
  return (
    <div className={`space-y-6 ${className}`} {...props}>
      {/* Header with back navigation */}
      <div className="space-y-4">
        {backLink && (
          <Link 
            to={backLink.href} 
            className="inline-flex items-center text-primary-600 hover:text-primary-800 transition-colors"
          >
            <ArrowLeft size={16} className="mr-2" />
            {backLink.label}
          </Link>
        )}
        
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            {subtitle && (
              <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
            )}
          </div>
          
          {actions && (
            <div className="flex space-x-3">
              {actions}
            </div>
          )}
        </div>
      </div>
      
      {/* Content */}
      <div>
        {children}
      </div>
    </div>
  );
};

export default DetailPageLayout;